import {
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  Switch,
} from '@ais-ui/ui-core';
import { UseFormReturn, FieldPath } from 'react-hook-form';
import { MapFormValues } from './useMapForm';

interface HoverLabelToggleProps {
  form: UseFormReturn<MapFormValues>;
  name: FieldPath<MapFormValues>;
  label: string;
  description: string;
}

export const HoverLabelToggle = ({
  form,
  name,
  label,
  description,
}: HoverLabelToggleProps) => {
  return (
    <FormField
      control={form.control}
      name={name}
      render={({ field }) => (
        <FormItem className="flex flex-row items-center justify-between border rounded-lg p-4 space-x-2">
          <div className="space-y-0.5">
            <FormLabel className="text-base">{label}</FormLabel>
            <FormDescription>{description}</FormDescription>
          </div>
          <FormControl>
            <Switch checked={field.value as boolean} onCheckedChange={field.onChange} />
          </FormControl>
        </FormItem>
      )}
    />
  );
};
